<app-breadcrumb [title]="'Gestión de Plan'" [items]="['Pesv']" [active_item]="'Gestión de Plan'"></app-breadcrumb>

<div class="container-fluid">
    <div class="card">
        <div class="card-header d-flex align-items-center bg-primary text-white">
            <i class="icofont icofont-file-document me-2"></i>
            <h5 class="mb-0"><strong>GESTIÓN DEL PLAN ANUAL DE TRABAJO</strong></h5>
        </div>

        <div class="card-body">
            <ul ngbNav #gestionTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

                <!-- ===================== TAB 1: OBJETIVOS ESPECÍFICOS ===================== -->
                <li [ngbNavItem]="1">
                    <a ngbNavLink>
                        <i class="icofont icofont-target me-1"></i> Objetivos Específicos
                    </a>
                    <ng-template ngbNavContent>

                        <div class="row mb-3 align-items-center mt-3">
                            <div class="col-md-4 ms-auto">
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm" placeholder="Buscar..."
                                        [(ngModel)]="filtroTexto" [ngModelOptions]="{standalone: true}">
                                    <span class="input-group-text">
                                        <i class="fa fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="!cargandoLista" class="table-responsive mt-2">
                            <ng-container *ngIf="objetivosFiltrados?.length > 0; else sinDatos">
                                <table id="tblObjetivosPlan" class="table table-bordered table-hover align-middle">
                                    <thead class="bg-primary text-white">
                                        <tr>
                                            <th class="text-center text-uppercase">Objetivo específico</th>
                                            <th class="text-center text-uppercase">Fecha creación</th>
                                            <th class="text-center text-uppercase">Estado</th>
                                            <th class="text-center text-uppercase">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let item of objetivosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page, id: 'objetivosPagination' }">
                                            <td>{{ item.objetivos || '-' }}</td>
                                            <td class="text-center">{{ item.fechaCreacion | date:'dd/MM/yyyy' }}</td>
                                            <td class="text-center">
                                                <span class="badge rounded-pill"
                                                    [ngClass]="item.estado === 1 ? 'bg-success' : 'bg-secondary'">
                                                    {{ item.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                <div class="d-flex justify-content-center gap-2">
                                                    <button
                                                        class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                        *ngIf="item.estado === 1" ngbTooltip="Editar"
                                                        (click)="abrirModalObjetivo(modalObjetivo, item)">
                                                        <i class="icofont icofont-pencil"
                                                            style="font-size: .85rem;"></i>
                                                    </button>
                                                    <button
                                                        class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                                        *ngIf="item.estado === 1" ngbTooltip="Inactivar"
                                                        (click)="cambiarEstado(item)">
                                                        <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                                                    </button>
                                                    <button
                                                        class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                        *ngIf="item.estado !== 1" ngbTooltip="Activar"
                                                        (click)="cambiarEstado(item)">
                                                        <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>

                            <ng-template #sinDatos>
                                <div class="text-center py-4 text-primary fst-italic">No hay objetivos registrados.
                                </div>
                            </ng-template>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mt-4">
                            <div class="d-flex align-items-center">
                                <label for="pageSizeObjetivos" class="me-2">Mostrar:</label>
                                <select id="pageSizeObjetivos" class="form-select w-auto" [(ngModel)]="pageSize"
                                    [ngModelOptions]="{standalone: true}" (change)="page = 1">
                                    <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                                </select>
                                <span class="ms-2">registros por página</span>
                            </div>

                            <div class="text-center flex-grow-1">
                                Total Registros:
                                <a class="badge badge-primary"><b>{{ objetivosFiltrados?.length || 0 }}</b></a>
                            </div>

                            <div class="text-end paginador-personalizado">
                                <pagination-controls id="objetivosPagination" (pageChange)="page = $event" [maxSize]="5"
                                    [directionLinks]="true" [autoHide]="true" previousLabel="Anterior"
                                    nextLabel="Siguiente"></pagination-controls>
                            </div>
                        </div>

                        <div class="mt-4">
                            <div class="btn-showcase text-center">
                                <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                                    (click)="exportarExcel('tblObjetivosPlan','Listado_Objetivos')">
                                    <i class="icofont icofont-file-excel"></i> EXCEL
                                </button>
                                <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                                    (click)="exportToPDF('tblObjetivosPlan','Listado_Objetivos','Listado de Objetivos')">
                                    <i class="icofont icofont-file-pdf"></i> PDF
                                </button>
                                <button type="button" class="btn btn-primary btn-sm"
                                    (click)="abrirModalObjetivo(modalObjetivo)">
                                    <i class="icofont icofont-plus me-1"></i>AGREGAR OBJETIVO
                                </button>
                            </div>
                        </div>

                    </ng-template>
                </li>

                <!-- ===================== TAB 3: RESPONSABILIDADES ===================== -->
                <li [ngbNavItem]="3">
                    <a ngbNavLink>
                        <i class="icofont icofont-badge me-1"></i> Responsabilidades
                    </a>
                    <ng-template ngbNavContent>

                        <div class="row mb-3 align-items-center mt-3">
                            <div class="col-md-4 ms-auto">
                                <div class="input-group">
                                    <input type="text" class="form-control"
                                        placeholder="Buscar por cargo o responsabilidad..."
                                        [(ngModel)]="filtroTextoResponsabilidades"
                                        [ngModelOptions]="{standalone: true}" />
                                    <span class="input-group-text">
                                        <i class="fa fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive mt-2">
                            <ng-container *ngIf="responsabilidadesFiltradas?.length > 0; else sinResponsabilidades">
                                <table id="tblResponsabilidadesPlan"
                                    class="table table-bordered table-hover align-middle">
                                    <thead class="bg-primary text-white">
                                        <tr>
                                            <th class="text-center">CARGO</th>
                                            <th class="text-center">RESPONSABILIDAD</th>
                                            <th class="text-center">ESTADO</th>
                                            <th class="text-center">ACCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let item of responsabilidadesFiltradas | paginate: { itemsPerPage: pageSizeResponsabilidades, currentPage: pageResponsabilidades, id: 'responsabilidadesPagination' }">
                                            <td class="text-center">{{ item.CargosData?.cargos || '-' }}</td>
                                            <td>
                                                <ng-container *ngIf="item.ResponsabilidadData?.length; else sinResp">
                                                    <ul class="mb-0 ps-3">
                                                        <li *ngFor="let resp of item.ResponsabilidadData">
                                                            {{ resp.descripcion }}
                                                        </li>
                                                    </ul>
                                                </ng-container>

                                                <ng-template #sinResp>
                                                    -
                                                </ng-template>
                                            </td>
                                            <td class="text-center">
                                                <span class="badge rounded-pill"
                                                    [ngClass]="item.estado === 1 ? 'bg-success' : 'bg-secondary'">
                                                    {{ item.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                <div class="d-flex justify-content-center gap-2">
                                                    <button
                                                        class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                        *ngIf="item.estado === 1" ngbTooltip="Editar"
                                                        (click)="abrirModalResponsabilidad(modalResponsabilidad, item)">
                                                        <i class="icofont icofont-pencil"
                                                            style="font-size: .85rem;"></i>
                                                    </button>
                                                    <button
                                                        class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                                        *ngIf="item.estado === 1" ngbTooltip="Inactivar"
                                                        (click)="cambiarEstadoResponsabilidad(item)">
                                                        <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                                                    </button>
                                                    <button
                                                        class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                        *ngIf="item.estado !== 1" ngbTooltip="Activar"
                                                        (click)="cambiarEstadoResponsabilidad(item)">
                                                        <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>

                            <ng-template #sinResponsabilidades>
                                <div class="text-center py-4 text-primary">No hay responsabilidades registradas.</div>
                            </ng-template>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mt-3">
                            <div class="d-flex align-items-center">
                                <label for="pageSizeResponsabilidades" class="me-2">Mostrar:</label>
                                <select id="pageSizeResponsabilidades" class="form-select w-auto"
                                    [(ngModel)]="pageSizeResponsabilidades" [ngModelOptions]="{standalone: true}"
                                    (change)="pageResponsabilidades = 1">
                                    <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                                </select>
                                <span class="ms-2">registros por página</span>
                            </div>

                            <div class="text-center flex-grow-1">
                                Total Registros:
                                <a class="badge badge-primary"><b>{{ responsabilidadesFiltradas?.length || 0 }}</b></a>
                            </div>

                            <div class="text-end">
                                <pagination-controls id="responsabilidadesPagination"
                                    (pageChange)="pageResponsabilidades = $event" [maxSize]="5" [directionLinks]="true"
                                    [autoHide]="true" previousLabel="Anterior"
                                    nextLabel="Siguiente"></pagination-controls>
                            </div>
                        </div>

                        <div class="mt-4">
                            <div class="btn-showcase text-center">
                                <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                                    (click)="exportarExcel('tblResponsabilidadesPlan','Listado_Responsabilidades')">
                                    <i class="icofont icofont-file-excel"></i> EXCEL
                                </button>
                                <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                                    (click)="exportToPDF('tblResponsabilidadesPlan','Listado_Responsabilidades','Listado de Responsabilidades')">
                                    <i class="icofont icofont-file-pdf"></i> PDF
                                </button>
                                <button type="button" class="btn btn-primary btn-sm"
                                    (click)="abrirModalResponsabilidad(modalResponsabilidad)">
                                    <i class="icofont icofont-plus me-1"></i>AGREGAR RESPONSABILIDAD
                                </button>
                            </div>
                        </div>

                    </ng-template>
                </li>
            </ul>

            <!-- Aquí se renderiza el contenido de la pestaña activa -->
            <div [ngbNavOutlet]="gestionTab" class="mt-2"></div>

        </div>
    </div>
</div>

<ng-template #modalMeta let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <i class="icofont icofont-edit me-2"></i>
            {{ metaEditando ? 'Editar meta' : 'Agregar meta' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="metaForm" novalidate>
            <div class="mb-3">
                <label class="form-label text-black">Tipo de meta: <span class="text-danger">*</span></label>

                <div class="input-group">
                    <ng-select [items]="tiposMeta" bindLabel="descripcion" bindValue="id"
                        placeholder="Seleccione el tipo de meta" formControlName="tipo_meta" [clearable]="false"
                        [class.is-invalid]="metaForm.get('tipo_meta')?.invalid && metaForm.get('tipo_meta')?.touched">
                    </ng-select>

                    <button class="btn btn-primary" type="button" (click)="abrirModal(modalCrearTipoMeta)"
                        ngbTooltip="Crear nuevo tipo de meta">
                        <i class="icon-plus"></i>
                    </button>
                </div>
                <div class="invalid-feedback d-block"
                    *ngIf="metaForm.get('tipo_meta')?.invalid && metaForm.get('tipo_meta')?.touched">
                    Debe seleccionar un tipo de meta.
                </div>
            </div>

            <div class="mb-2">
                <label class="form-label text-black">Descripción: <span class="text-danger">*</span></label>
                <textarea class="form-control" rows="4" maxlength="2000" formControlName="descripcion"
                    [class.is-invalid]="metaForm.get('descripcion')?.invalid && metaForm.get('descripcion')?.touched">
                </textarea>
                <div class="invalid-feedback"
                    *ngIf="metaForm.get('descripcion')?.invalid && metaForm.get('descripcion')?.touched">
                    Este campo es obligatorio (máx. 2000 caracteres).
                </div>
                <small class="text-secondary">Máximo 2000 caracteres.</small>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
            [disabled]="guardandoMeta">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="guardarMeta(modal)" [disabled]="guardandoMeta">
            <span *ngIf="!guardandoMeta">
                <i class="icofont icofont-save me-1"></i>{{ metaEditando ? 'Guardar cambios' : 'Guardar meta' }}
            </span>
            <span *ngIf="guardandoMeta">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
            </span>
        </button>
    </div>
</ng-template>

<ng-template #modalObjetivo let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <i class="icofont icofont-edit me-2"></i>
            {{ objetivoEditando ? 'Editar objetivo específico' : 'Agregar objetivos específicos' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
        <form *ngIf="objetivoEditando" [formGroup]="editarForm" novalidate>
            <label class="form-label text-black">Objetivo específico: <span class="text-danger">*</span></label>
            <textarea class="form-control" rows="4" maxlength="2000" formControlName="objetivos"
                [class.is-invalid]="editarForm.get('objetivos')?.invalid && editarForm.get('objetivos')?.touched">
            </textarea>
            <div class="invalid-feedback"
                *ngIf="editarForm.get('objetivos')?.invalid && editarForm.get('objetivos')?.touched">
                Este campo es obligatorio (máx. 2000 caracteres).
            </div>
            <small class="text-secondary">Máximo 2000 caracteres.</small>
        </form>

        <form *ngIf="!objetivoEditando" [formGroup]="objetivosForm" novalidate>
            <div formArrayName="objetivos">
                <div class="row g-2 align-items-start mb-2" *ngFor="let item of objetivosArray.controls; let i = index"
                    [formGroupName]="i">

                    <div class="col-auto pt-2">
                        <span class="badge bg-secondary">{{ i + 1 }}</span>
                    </div>

                    <div class="col">
                        <textarea class="form-control" rows="2" maxlength="2000" formControlName="objetivos"
                            placeholder="Ej: Fortalecer la cultura de seguridad vial en todos los colaboradores."
                            [class.is-invalid]="item.get('objetivos')?.invalid && item.get('objetivos')?.touched">
                        </textarea>
                        <div class="invalid-feedback"
                            *ngIf="item.get('objetivos')?.invalid && item.get('objetivos')?.touched">
                            Este campo es obligatorio (máx. 2000 caracteres).
                        </div>
                    </div>

                    <div class="col-auto pt-1">
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="eliminarFila(i)"
                            ngbTooltip="Quitar fila">
                            <i class="icofont icofont-ui-delete"></i>
                        </button>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-outline-primary btn-sm mt-2" (click)="agregarFila()">
                <i class="icofont icofont-plus me-1"></i>Agregar otro objetivo
            </button>
        </form>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
            [disabled]="guardando || guardandoEdicion">Cancelar</button>

        <button *ngIf="!objetivoEditando" type="button" class="btn btn-primary" (click)="guardarTodos(modal)"
            [disabled]="guardando">
            <span *ngIf="!guardando"><i class="icofont icofont-save me-1"></i>Guardar objetivos</span>
            <span *ngIf="guardando">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
            </span>
        </button>

        <button *ngIf="objetivoEditando" type="button" class="btn btn-primary" (click)="guardarEdicion(modal)"
            [disabled]="guardandoEdicion">
            <span *ngIf="!guardandoEdicion"><i class="icofont icofont-save me-1"></i>Guardar cambios</span>
            <span *ngIf="guardandoEdicion">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
            </span>
        </button>
    </div>
</ng-template>

<ng-template #modalResponsabilidad let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <i class="icofont icofont-edit me-2"></i>
            {{ responsabilidadEditando ? 'Editar responsabilidad' : 'Agregar responsabilidad' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">

        <!-- Selección del cargo -->
        <form [formGroup]="responsabilidadForm" novalidate>
            <div class="mb-3">
                <label class="form-label text-black">Cargo: <span class="text-danger">*</span></label>
                <ng-select [items]="cargosDisponibles" bindLabel="cargos" bindValue="id"
                    placeholder="Seleccione el cargo" formControlName="id_cargo" [clearable]="false"
                    [class.is-invalid]="responsabilidadForm.get('id_cargo')?.invalid && responsabilidadForm.get('id_cargo')?.touched">
                </ng-select>
                <div class="invalid-feedback d-block"
                    *ngIf="responsabilidadForm.get('id_cargo')?.invalid && responsabilidadForm.get('id_cargo')?.touched">
                    Debe seleccionar un cargo.
                </div>
            </div>
        </form>

        <hr>

        <!-- Loader mientras trae las descripciones existentes -->
        <div *ngIf="cargandoResponsabilidadDes" class="text-center py-3">
            <span class="spinner-border spinner-border-sm me-2"></span>Cargando responsabilidades...
        </div>

        <!-- FormArray de descripciones de responsabilidad -->
        <form *ngIf="!cargandoResponsabilidadDes" [formGroup]="responsabilidadDesForm" novalidate>
            <label class="form-label text-black">Responsabilidades: <span class="text-danger">*</span></label>

            <div formArrayName="descripciones">
                <div class="row g-2 align-items-start mb-2"
                    *ngFor="let item of responsabilidadDesArray.controls; let i = index" [formGroupName]="i">

                    <div class="col-auto pt-2">
                        <span class="badge bg-secondary">{{ i + 1 }}</span>
                    </div>

                    <div class="col">
                        <input type="text" class="form-control" formControlName="descripcion"
                            placeholder="Ej: Cumplir las normas de tránsito vigentes."
                            [class.is-invalid]="item.get('descripcion')?.invalid && item.get('descripcion')?.touched">
                        <div class="invalid-feedback"
                            *ngIf="item.get('descripcion')?.invalid && item.get('descripcion')?.touched">
                            Este campo es obligatorio (máx. 500 caracteres).
                        </div>
                    </div>

                    <div class="col-auto pt-1">
                        <button type="button" class="btn btn-outline-danger btn-sm"
                            (click)="eliminarFilaResponsabilidadDes(i)" ngbTooltip="Quitar responsabilidad">
                            <i class="icofont icofont-ui-delete"></i>
                        </button>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-outline-primary btn-sm mt-1" (click)="agregarFilaResponsabilidadDes()">
                <i class="icofont icofont-plus me-1"></i>Agregar otra responsabilidad
            </button>
        </form>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
            [disabled]="guardandoResponsabilidad">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="guardarResponsabilidad(modal)"
            [disabled]="guardandoResponsabilidad || cargandoResponsabilidadDes">
            <span *ngIf="!guardandoResponsabilidad">
                <i class="icofont icofont-save me-1"></i>{{ responsabilidadEditando ? 'Guardar cambios' : 'Guardar
                responsabilidad' }}
            </span>
            <span *ngIf="guardandoResponsabilidad">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
            </span>
        </button>
    </div>
</ng-template>

<ng-template #modalIndicador let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <i class="icofont icofont-chart-bar-graph me-2"></i>
            {{ indicadorEditando ? 'Editar indicador' : 'Agregar indicadores' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">

        <!-- Loader mientras trae el dato por ID -->
        <div *ngIf="cargandoIndicador" class="text-center py-4">
            <span class="spinner-border spinner-border-sm me-2"></span>Cargando indicador...
        </div>

        <!-- ===== EDICIÓN INDIVIDUAL ===== -->
        <form *ngIf="indicadorEditando && !cargandoIndicador" [formGroup]="editarIndicadorForm" novalidate>
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="form-label text-black">Nombre del indicador: <span
                            class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="nombre_indicador"
                        placeholder="Ej: DE CUMPLIMIENTO DEL TRABAJO"
                        [class.is-invalid]="editarIndicadorForm.get('nombre_indicador')?.invalid && editarIndicadorForm.get('nombre_indicador')?.touched">
                    <div class="invalid-feedback"
                        *ngIf="editarIndicadorForm.get('nombre_indicador')?.invalid && editarIndicadorForm.get('nombre_indicador')?.touched">
                        Este campo es obligatorio.
                    </div>
                </div>

                <div class="col-md-6">
                    <label class="form-label text-black">Tipo de cálculo: <span class="text-danger">*</span></label>
                    <ng-select [items]="tiposCalculo" bindLabel="nombre" bindValue="id" placeholder="Seleccione..."
                        formControlName="tipo_calculo" [clearable]="false"
                        [class.is-invalid]="editarIndicadorForm.get('tipo_calculo')?.invalid && editarIndicadorForm.get('tipo_calculo')?.touched">
                    </ng-select>
                    <div class="invalid-feedback d-block"
                        *ngIf="editarIndicadorForm.get('tipo_calculo')?.invalid && editarIndicadorForm.get('tipo_calculo')?.touched">
                        Debe seleccionar un tipo de cálculo.
                    </div>
                </div>

                <div class="col-md-5">
                    <label class="form-label text-black">Numerador: <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="numerador"
                        placeholder="Ej: Actividades Ejecutadas"
                        [class.is-invalid]="editarIndicadorForm.get('numerador')?.invalid && editarIndicadorForm.get('numerador')?.touched">
                </div>

                <div class="col-md-5">
                    <label class="form-label text-black">Denominador: <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="denominador"
                        placeholder="Ej: Actividades Programadas"
                        [class.is-invalid]="editarIndicadorForm.get('denominador')?.invalid && editarIndicadorForm.get('denominador')?.touched">
                </div>

                <div class="col-md-2">
                    <label class="form-label text-black">Factor: <span class="text-danger">*</span></label>
                    <input type="number" class="form-control" formControlName="factor"
                        [class.is-invalid]="editarIndicadorForm.get('factor')?.invalid && editarIndicadorForm.get('factor')?.touched">
                </div>

                <div class="col-md-6">
                    <label class="form-label text-black">Meta: <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="meta"
                        placeholder="Ej: >95%, 100%, Tendencia decreciente"
                        [class.is-invalid]="editarIndicadorForm.get('meta')?.invalid && editarIndicadorForm.get('meta')?.touched">
                </div>

                <div class="col-md-6">
                    <label class="form-label text-black">Periodicidad:</label>
                    <ng-select [items]="periodicidades" placeholder="Seleccione..." formControlName="periodicidad">
                    </ng-select>
                </div>
            </div>
        </form>

        <!-- ===== CREACIÓN MASIVA ===== -->
        <form *ngIf="!indicadorEditando" [formGroup]="indicadoresForm" novalidate>
            <div formArrayName="indicadores">
                <div class="card border mb-3" *ngFor="let item of indicadoresArray.controls; let i = index"
                    [formGroupName]="i">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <span class="badge bg-secondary">Indicador {{ i + 1 }}</span>
                            <button type="button" class="btn btn-outline-danger btn-sm"
                                (click)="eliminarFilaIndicador(i)" ngbTooltip="Quitar indicador">
                                <i class="icofont icofont-ui-delete"></i>
                            </button>
                        </div>

                        <div class="row g-2">
                            <div class="col-md-6">
                                <label class="form-label small text-black">Nombre del indicador <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="nombre_indicador" placeholder="Ej: DE CUMPLIMIENTO DEL TRABAJO"
                                    [class.is-invalid]="item.get('nombre_indicador')?.invalid && item.get('nombre_indicador')?.touched">
                            </div>

                            <div class="col-md-6">
                                <label class="form-label small text-black">Tipo de cálculo <span
                                        class="text-danger">*</span></label>
                                <ng-select [items]="tiposCalculo" bindLabel="nombre" bindValue="id"
                                    placeholder="Seleccione..." formControlName="tipo_calculo" [clearable]="false">
                                </ng-select>
                            </div>

                            <div class="col-md-5">
                                <label class="form-label small text-black">Numerador <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control form-control-sm" formControlName="numerador"
                                    placeholder="Ej: Actividades Ejecutadas"
                                    [class.is-invalid]="item.get('numerador')?.invalid && item.get('numerador')?.touched">
                            </div>

                            <div class="col-md-5">
                                <label class="form-label small text-black">Denominador <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control form-control-sm" formControlName="denominador"
                                    placeholder="Ej: Actividades Programadas"
                                    [class.is-invalid]="item.get('denominador')?.invalid && item.get('denominador')?.touched">
                            </div>

                            <div class="col-md-2">
                                <label class="form-label small text-black">Factor <span
                                        class="text-danger">*</span></label>
                                <input type="number" class="form-control form-control-sm" formControlName="factor">
                            </div>

                            <div class="col-md-6">
                                <label class="form-label small text-black">Meta <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control form-control-sm" formControlName="meta"
                                    placeholder="Ej: >95%, 100%, Tendencia decreciente"
                                    [class.is-invalid]="item.get('meta')?.invalid && item.get('meta')?.touched">
                            </div>

                            <div class="col-md-6">
                                <label class="form-label small text-black">Periodicidad</label>
                                <ng-select [items]="periodicidades" placeholder="Seleccione..."
                                    formControlName="periodicidad">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-outline-primary btn-sm" (click)="agregarFilaIndicador()">
                <i class="icofont icofont-plus me-1"></i>Agregar otro indicador
            </button>
        </form>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
            [disabled]="guardandoIndicador || guardandoEdicionIndicador">Cancelar</button>

        <button *ngIf="!indicadorEditando" type="button" class="btn btn-primary"
            (click)="guardarTodosIndicadores(modal)" [disabled]="guardandoIndicador">
            <span *ngIf="!guardandoIndicador"><i class="icofont icofont-save me-1"></i>Guardar indicadores</span>
            <span *ngIf="guardandoIndicador">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
            </span>
        </button>

        <button *ngIf="indicadorEditando" type="button" class="btn btn-primary" (click)="guardarEdicionIndicador(modal)"
            [disabled]="guardandoEdicionIndicador || cargandoIndicador">
            <span *ngIf="!guardandoEdicionIndicador"><i class="icofont icofont-save me-1"></i>Guardar cambios</span>
            <span *ngIf="guardandoEdicionIndicador">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
            </span>
        </button>
    </div>
</ng-template>

<ng-template #modalCrearTipoMeta let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title"><i class="icofont icofont-plus me-2"></i>Crear nuevo tipo de meta</h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
        <div class="mb-3">
            <label class="form-label text-black">Descripción del tipo de meta <span
                    class="text-danger">*</span></label>
            <input #descripcionInput type="text" class="form-control text-uppercase"
                placeholder="Ingrese la descripción..." />
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="crearNuevoTipoMeta(descripcionInput.value, modal)">
            <i class="icofont icofont-save me-1"></i>Crear tipo de meta
        </button>
    </div>
</ng-template>